import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import find from 'lodash/find';
import get from 'lodash/get';
import compact from 'lodash/compact';
import join from 'lodash/join';
import { useUrl } from 'hooks';
import Avatar from 'components/Avatar';
import Chip from 'components/Chip';
import LinkTile from 'components/LinkTile';
import App from 'modules/App';
import messages from '../../messages';
import styles from '../../OrganizationLogo.pcss';
const getCountry = (organization)=>{
    const { countryCode: alpha2Code } = organization;
    const countries = useSelector(App.selectors.countries);
    const country = find(countries, {
        alpha2Code
    });
    const localizationResources = useSelector(App.selectors.localizationResources);
    return get(localizationResources, [
        country.nameKey,
        'value'
    ], country.englishName);
};
const getInfoMessage = (organization)=>{
    const country = getCountry(organization);
    const { street, city, zipCode } = organization;
    const infoItems = compact([
        country,
        street,
        city,
        zipCode
    ]);
    return join(infoItems, ', ');
};
const StatusChip = ({ organizationMembership })=>{
    const { status, organization } = organizationMembership;
    if (organization.status === 'Pending') {
        return /*#__PURE__*/ _jsx(Chip, {
            className: "ml-5",
            styleModifier: "error",
            labelMessage: messages.tags.notApproved
        });
    }
    if (status === 'Active') {
        return null;
    }
    if (status === 'Invitation') {
        return /*#__PURE__*/ _jsx(Chip, {
            className: "ml-5",
            styleModifier: "error",
            labelMessage: messages.tags.invitation
        });
    }
    if (status === 'Pending') {
        return /*#__PURE__*/ _jsx(Chip, {
            className: "ml-5",
            styleModifier: "success",
            labelMessage: messages.tags.pending
        });
    }
    return null;
};
const AdminChip = ({ organizationMembership })=>{
    const { isAdmin } = organizationMembership;
    if (!isAdmin) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Chip, {
        className: "ml-5",
        labelMessage: messages.tags.admin
    });
};
const HeadMessage = ({ organizationMembership })=>/*#__PURE__*/ _jsxs("div", {
        className: "d-flex align-items-center mb-2",
        children: [
            /*#__PURE__*/ _jsx("span", {
                children: organizationMembership.organization.name
            }),
            /*#__PURE__*/ _jsx(StatusChip, {
                organizationMembership: organizationMembership
            }),
            /*#__PURE__*/ _jsx(AdminChip, {
                organizationMembership: organizationMembership
            })
        ]
    });
const OrganizationBox = ({ organizationMembership })=>{
    if (organizationMembership.status === 'Invitation') {
        return null;
    }
    const { organization } = organizationMembership;
    const { organizationUID, logo, name } = organization;
    const detailsUrl = useUrl('organization-membership-details', {
        organizationUID
    });
    return /*#__PURE__*/ _jsx(LinkTile, {
        to: detailsUrl,
        labelMessage: /*#__PURE__*/ _jsx(HeadMessage, {
            organizationMembership: organizationMembership
        }),
        infoMessage: getInfoMessage(organization),
        image: /*#__PURE__*/ _jsx(Avatar, {
            avatarImg: logo,
            name: name,
            size: 48,
            className: styles.logo
        })
    });
};
export default withStyles(styles)(OrganizationBox);
